export enum EMissionType {
    ENTIRE_COLUMNS_1,
    ENTIRE_COLUMNS_2,
    COVER,
    VORSATZ
}